import Action from '../../../Action'
import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../../../LoadSimple';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { lang } from '../../../generales/traduction';
import { useFetch } from '../../../../hooks/useFetch';
const ImportInfo =({buscar_cis,handleShowPopup,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
  const [file, setFile] = useState(null);
  const [disabled,setDisabled]=useState(true)
  const [msgError,setMsgError]=useState(true)
  const [boolError,setBoolError]=useState(false)
  const [response,setResponse]=useState([])
  const [loading,setLoading]=useState(false)
  const [dataGroups,setDataGroups]=useState([])
  const dataBot=useFetch('cassia/media/telegram/config','','','GET',server)
  const fileInputRef = useRef(null);
  useEffect(()=>{
    buscar_grupos()
  },[])
  const buscar_grupos = () => {
    setLoading(true)
    
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url+'/api/v1/cassia/media/telegram/groups/discovery_new_groups',
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setDataGroups(data1.data);
          setLoading(false)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };


  // Función para leer el archivo
  const Registrar=(element)=>{
    let method='POST'






    setLoading(true)
    const fetchDataPost = async () => {
      const body={
          "name": element.name,
          "groupid": element.groupid,
          "mensaje": element.mensaje
      }
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/media/telegram/groups/link', {
       method: method,  
       headers: {
          "Accept": "application/json",
         // 'Content-Type': 'application/json',
         'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(body),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       // Manejo de la respuesta
     
       buscar_grupos()
       buscar_cis()
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(lang[languaje]['vinculadoCorrect']),'', true)
       // console.log(data1);
     
    
   
     } else {
       const data1 = await response.json();
       handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['vinculadoIncorrect']),data1.detail, false)
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          
          
      setLoading(false)
        
        // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
       
        console.error(error);
      }
    };

    fetchDataPost();
  }

  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {lang[languaje]['descubrirGruos'].toUpperCase()}
                  </div>
              </div>
              <div className='content-card-modal-gs'  style={{height:'95%'}}>
              {dataBot.data.length==0?<div className="cont-load-user-list">
                                  <LoadSimple></LoadSimple>
                                </div>
              :
              <>
                  <div className="cont-import-GS-box" style={{height:'100%'}}> 
                      <div className='row-cont-input-file instructions'  style={{height:'20%',display:'block'}} >
                          <div className='rowInstructions' style={{fontWeight:'bold'}}>{lang[languaje]['msgVisualisarGrupos']} </div>
                          <div className='rowInstructions'>{"1. "+lang[languaje]['msgVisualisarGrupos1']} </div>
                          <div className='rowInstructions'>{"2. "+lang[languaje]['msgVisualisarGrupos2']+""+dataBot.data.data.find(item => item.name === "bot_name")?.value} </div>
                          <div className='rowInstructions'>{"3. "+lang[languaje]['msgVisualisarGrupos3']+""+dataBot.data.data.find(item => item.name === "bot_name")?.value} </div>
                          <div className='rowInstructions'>{"4. "+lang[languaje]['msgVisualisarGrupos4']+" "+dataBot.data.data.find(item => item.name === "group_secret_word_verify")?.value} </div>
                          <div className='rowInstructions titleInstructions'>{lang[languaje]['gruposDescubiertos'].toUpperCase()} </div>
                      </div>
                      <div className='row-cont-input-table' style={{height:'65%',border:'1px solid var(--border-table-color)',borderRadius:'var(--border-radios-small)'}}>
                      
                         
                          <>
                          <div className="cont-table-portafolio">
                            <div className={"head-table-portafolio"+mode}>
                              <div className="compact-head-table-portafolio"> 
                                <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}}>{'Group ID'}</div>
                                <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
                                <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['accion'])}</div>
                              </div> 
                            </div>
                            <div className="body-table-portafolio">
                              {loading ? (
                                <div className="cont-load-user-list">
                                  <LoadSimple></LoadSimple>
                                </div>
                              ) : (
                                <>
                                <div className="cont-row-user-list">
                                    {loading ? (
                                      <div className="cont-load-user-list">
                                        <LoadSimple></LoadSimple>
                                      </div>
                                    ) : (
                                      
                                      dataGroups
                                        .map((elemento, indice) => (
                                          <div
                                            className={"row-table-portafolio"+mode}
                                            key={indice}
                                          >
                                            
                                            <div className="field-body-table-mantenimiento field-small"  style={{width:'40%'}}>
                                              {elemento.groupid}
                                            </div>
                                            <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                                              {elemento.name}
                                            </div>
                                            <div className="field-body-table-mantenimiento field-larger"  style={{width:'20%'}}>
                                            <Action disabled={false} origen='Green' titulo={capitalizeFirstLetter(lang[languaje]['vincular'])}  action={()=>Registrar(elemento)}/>
                                            </div>
                                          
                                            
                                          </div>
                                        ))
                                    )}
                                    { 
                                    dataGroups.length == 0  && loading==false ? (
                                      <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                    ) : (
                                      ""
                                    )
                                    }
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          </>
                       

      
                      
                      </div>
                      <div className='row-cont-input-buttons'>
                      {(importLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                      (
                      <>
                      <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeImportModal}/>
                      {/* <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['importar'])}  action={handleImport}/> */}
                      </>
                      )
                      }
                      </div>           
                  </div>
                  </>
                  }
              </div>
              </div>
      </div>
  )
}

export default ImportInfo